import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import {ProtectedPrivacyService} from '@app/services/ui/protected-privacy.service';

@Component({
	selector: 'app-privacy-toggle-big-button',
	templateUrl: './privacy-toggle-big-button.component.html',
	styleUrls: ['./privacy-toggle-big-button.component.scss'],
})
export class PrivacyToggleBigButtonComponent implements OnDestroy {
	isPrivacyModusActive: boolean;
	private subscription = new Subscription();

	constructor(private privacyService: ProtectedPrivacyService) {
		this.isPrivacyModusActive = privacyService.statusProtected;
		this.subscription.add(privacyService.toggleChange$().subscribe(status => this.isPrivacyModusActive = status));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	toggle(): void {
		this.privacyService.toggleStatus();
	}
}
